import type { LoadResult, LoadResultObject } from "devextreme/common/data/custom-store";
import { APIService, type APICallbacks, type APIOptions } from "@sieg-ad/fetch";
import { useAuthStore } from "~/store/auth";

interface LoadResultData<T> {
  dxResult: LoadResultObject<T>;
  list: (number | string)[];
}

class AtlasAPIService extends APIService {
  constructor(baseURL: string, options: APICallbacks) {
    super(baseURL, options);
  }

  async getDx<T = any>(url: string, options: APIOptions<LoadResult<T>> = {}) {
    return this.get<LoadResult<T>>(url, options);
  }

  async getDxFilter<T = any>(url: string, options: APIOptions<LoadResult<T>> = {}) {
    return this.get<LoadResult<T>>(url, options);
  }
}

export const API = new AtlasAPIService(useRuntimeConfig().public.API_URL, {
  onError({ error }) {
    switch (error.type) {
      case 'warn':
        warnToast(error.message);
        break;
      case 'error':
        errorToast(error.message);
        break;
      default:
        errorToast(error.message);
    }
  },
  setUser(user: Record<string, any> | null = null) {
    useAuthStore().setUser(user as any);
  },
  getToken() {
    const { token } = storeToRefs(useAuthStore());
    return token.value;
  }
});